import React from "react"

function createScroller() {
  let scrollNode: HTMLElement | null = null
  return {
    setScrollNode(node: HTMLElement | null) {
      scrollNode = node

      return () => {
        scrollNode = null
      }
    },
    scroll() {
      const currentScrollNode = scrollNode
      if (currentScrollNode !== null) {
        requestAnimationFrame(() => {
          currentScrollNode.scrollIntoView({ block: "center" })
        })
      }
    },
  }
}

const ScrollerContext = React.createContext<ReturnType<
  typeof createScroller
> | null>(null)

export default function ScrollerProvider({
  children,
}: React.PropsWithChildren) {
  return (
    <ScrollerContext.Provider value={createScroller()}>
      {children}
    </ScrollerContext.Provider>
  )
}

export function useScroller() {
  const scroller = React.use(ScrollerContext)

  if (scroller === null) {
    throw new Error("Scroller must be within a ScrollProvider")
  }

  return scroller
}
